import { useState } from "react";
import { Card, CardContent, useTheme } from "@mui/material";
import { Button } from "@mui/material";
import { TextField, Typography } from "@mui/material";
import { Table, TableHead, TableRow, TableCell, TableBody } from "@mui/material";
import { tokens } from "../theme";
import axios from "axios";
import baseURL from "../config";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { toast, ToastContainer } from "react-toastify";

export default function NettingReport() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [month, setMonth] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
 

  const getDecryptedToken = () => {
      const encryptedToken = Cookies.get("token");
      if (!encryptedToken) return null;
  
      const secretKey = '19092002'; 
      const bytes = CryptoJS.AES.decrypt(encryptedToken, secretKey);
      const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
  
      return decryptedToken || null;
    };
  
   
    const token = getDecryptedToken();

  const fetchData = async () => {
    if (!month) return;
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/api/BonusPoints/NettingBonusPointsByMonth`, {
        params: { month: `${month}-01T00:00:00Z` },
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(response.data.companies);
   
      if(response.data.success == false){
        toast.error("Nuk mund te zgjidhni ate muaj!");
        setData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  return (
    <Card sx={{ p: 3, maxWidth: 600, mx: "auto", mt: 5 }}>
        <ToastContainer />
      <CardContent>
        <h2 style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>Netting Report</h2>
        <div style={{ display: "flex", gap: "1rem", marginBottom: "1rem" }}>
          <TextField
            type="month"
            value={month}
            onChange={(e) => setMonth(e.target.value)}
            label="Select Month"
            variant="outlined"
            fullWidth
          />
          <Button onClick={fetchData} variant="contained" color = "primary" disabled={loading} cursor="pointer">
            {loading ? "Loading..." : "Get Report"}
          </Button>
        </div>

        <Table>
          <TableHead>
            <TableRow>
              <TableCell><b>Company Name</b></TableCell>
              <TableCell><b>Points Earned</b></TableCell>
              <TableCell><b>Points Used</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
     
        
            {data.length > 0 ? (
              data.map((company, index) => (
                <TableRow key={company.companyId || index}>
                  <TableCell>{company.companyName}</TableCell>
                  <TableCell>{company.totalPointsEarned}</TableCell>
                  <TableCell>{company.totalPointsUsed}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan="3" align="center" sx={{ py: 2 }}>
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}